import { render, staticRenderFns } from "./RightMenuConstainer.vue?vue&type=template&id=5c56b6ce&scoped=true"
import script from "./RightMenuConstainer.vue?vue&type=script&lang=js"
export * from "./RightMenuConstainer.vue?vue&type=script&lang=js"
import style0 from "./RightMenuConstainer.vue?vue&type=style&index=0&id=5c56b6ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c56b6ce",
  null
  
)

export default component.exports